/* Active 10 — Scroll Reveal Animations & Interactions */
(function() {
  'use strict';

  /* Add reveal classes to key sections */
  function initRevealElements() {
    var selectors = [
      '.module-wrapper',
      '.alternating-content-item',
      '.feature',
      '.product-list-item',
      '.recommended-products',
      '.product-trust-badges',
      '.product-reviews-section'
    ];

    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el, i) {
        if (!el.classList.contains('a10-reveal')) {
          el.classList.add('a10-reveal');
          /* Stagger items in groups */
          if (sel === '.feature' || sel === '.product-list-item') {
            var delay = (i % 4) + 1;
            el.classList.add('a10-reveal-delay-' + delay);
          }
        }
      });
    });
  }

  /* Intersection Observer for scroll reveals */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      /* Fallback: show everything */
      document.querySelectorAll('.a10-reveal').forEach(function(el) {
        el.classList.add('a10-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('a10-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.a10-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* Parallax-lite: subtle movement on hero */
  function initHeroParallax() {
    var hero = document.querySelector('.static-slideshow-wrapper');
    if (!hero) return;

    window.addEventListener('scroll', function() {
      var scrolled = window.pageYOffset;
      if (scrolled < window.innerHeight) {
        var slideText = hero.querySelector('.slide-text');
        if (slideText) {
          slideText.style.transform = 'translate(-50%, calc(-50% + ' + (scrolled * 0.15) + 'px))';
          slideText.style.opacity = 1 - (scrolled / (window.innerHeight * 0.8));
        }
      }
    }, { passive: true });
  }

  /* Smooth counter animation for stats if any */
  function initCountUp() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-count'));
          var duration = 2000;
          var start = 0;
          var startTime = null;

          function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(eased * target).toLocaleString();
            if (progress < 1) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  /* Init everything */
  function init() {
    initRevealElements();
    initScrollReveal();
    initHeroParallax();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
